import React from "react";
import { Badge } from "./ui/badge";

export const STATUS_ORCAMENTO_OPCOES = [
  { codigo: "ENVIADO", nome: "Enviado" },
  { codigo: "EM_NEGOCIACAO", nome: "Em Negociação" },
  { codigo: "GANHO", nome: "Ganho" },
  { codigo: "PERDIDO", nome: "Perdido" },
];

export const STATUS_ORCAMENTO_LABEL = STATUS_ORCAMENTO_OPCOES.reduce(
  (acc, o) => ({ ...acc, [o.codigo]: o.nome }),
  {}
);

const STATUS_STYLES = {
  ENVIADO: "bg-slate-100 text-slate-700",
  EM_NEGOCIACAO: "bg-amber-100 text-amber-900",
  GANHO: "bg-emerald-100 text-emerald-800",
  PERDIDO: "bg-rose-100 text-rose-800",
};

/** Selo visual do status do orçamento (funil de vendas). */
export const StatusBadge = ({ status, className = "", testid }) => {
  const codigo = status || "ENVIADO";
  return (
    <Badge
      className={`text-[10px] uppercase ${STATUS_STYLES[codigo] || STATUS_STYLES.ENVIADO} ${className}`}
      data-testid={testid}
    >
      {STATUS_ORCAMENTO_LABEL[codigo] || codigo}
    </Badge>
  );
};
